import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

import {
  CreateAccountStepsIndicator,
  OnboardingPageLayout,
} from '../components';

const PendingPage = () => {
  const { t } = useTranslation(['onboarding']);

  const steps = [
    { label: t('steps.profile') },
    { label: t('steps.training') },
    { label: t('steps.registration') },
  ];

  return (
    <OnboardingPageLayout>
      <CreateAccountStepsIndicator
        steps={steps}
        activeStep={2}
        completedSteps={[0, 1, 2]}
      />

      <Box
        sx={{
          mt: 2,
          borderRadius: 2,
          bgcolor: 'background.paper',
          border: '1px solid',
          borderColor: 'grey.300',
          boxShadow: '0 4px 16px rgba(0,0,0,0.12), 0 2px 6px rgba(0,0,0,0.08)',
          px: { xs: 2.5, sm: 4 },
          py: { xs: 4, sm: 5 },
          textAlign: 'center',
        }}
      >
        <AccessTimeOutlinedIcon
          sx={{ fontSize: 56, color: 'grey.500', mb: 2 }}
        />

        <Typography
          variant="h6"
          component="h1"
          sx={{
            mb: 2.5,
            width: '100%',
            fontSize: 24,
            fontWeight: 500,
          }}
        >
          {t('registration.pending.title')}
        </Typography>

        <Typography
          variant="body1"
          sx={{
            width: '100%',
            fontSize: 16,
            lineHeight: 1.5,
            fontWeight: 400,
          }}
        >
          {t('registration.pending.description')}
        </Typography>
      </Box>
    </OnboardingPageLayout>
  );
};

export default PendingPage;
